import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-masters',
    template: '<p>masters works!</p>',
    standalone: false
})
export class MastersComponent {

  constructor() { }

}
